import { gql } from '@apollo/client'

import { CHAT_CUSTOMER_FRAGMENT } from 'Const'

export const SIGN_IN_ANONYMOUSLY = gql`
  mutation SignInAnonymously {
    signInAnonymouslyCustomer {
      customer {
        ...ChatCustomer
      }
    }
  }
  ${CHAT_CUSTOMER_FRAGMENT}
`
